<p-confirmDialog key="modify" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="OptionMainDiv">
	<h4>Search for Students to Assign</h4>

	<div class="OptionGrid2Col">
		<label>Route Number:</label>
		<label style="color: Blue">{{ BusRouteNbr }}</label>

		<label>Route Description:</label>
		<label style="color: Blue">{{ BusRouteDesc }}</label>

		<label>Route Type:</label>
		<label style="color: Blue">{{ BusRouteTypeDesc }}</label>

		<label>School:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstSchool"
			[(ngModel)]="School"
			optionLabel="SchoolName"
			[filter]="true"
			filterBy="SchoolFullName"
			[showClear]="false"
			placeholder="Select a School"
			(ngModelChange)="onSchoolChange($event)"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="School">
					<div class="form-control NoBorder" style="text-align: left">
						{{ School.SchoolFullName }}
					</div>
				</div>
			</ng-template>
			<ng-template let-SchoolItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ SchoolItem.SchoolFullName }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Grade Level:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstGradeLevel"
			[(ngModel)]="GradeLevel"
			optionLabel="GradeLevelDesc"
			[filter]="true"
			filterBy="GradeLevelDesc"
			[showClear]="false"
			placeholder="Select a Grade Level"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="GradeLevel">
					<div class="form-control NoBorder" style="text-align: left">
						{{ GradeLevel.GradeLevelDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-GradeLevelItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ GradeLevelItem.GradeLevelDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Academy:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstAcademy"
			[(ngModel)]="Academy"
			optionLabel="AcademyDesc"
			[filter]="true"
			filterBy="AcademyDesc"
			[showClear]="false"
			placeholder="Select an Academy"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="GradeLevel">
					<div class="form-control NoBorder" style="text-align: left">
						{{ Academy.AcademyDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-AcademyItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ AcademyItem.AcademyDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Homeroom:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstHomeroomData"
			[(ngModel)]="Homeroom"
			optionLabel="HomeRoom"
			[filter]="true"
			filterBy="HomeRoom"
			[showClear]="false"
			placeholder="Select a Homeroom"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="Homeroom">
					<div class="form-control NoBorder" style="text-align: left">
						{{ Homeroom.HomeRoom }}
					</div>
				</div>
			</ng-template>
			<ng-template let-HomeroomItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ HomeroomItem.HomeRoom }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Group:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstGroup"
			[(ngModel)]="Group"
			optionLabel="GroupName"
			[filter]="true"
			filterBy="GroupDesc"
			[showClear]="false"
			placeholder="Select a Group"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="Group">
					<div class="form-control NoBorder" style="text-align: left">
						{{ Group.GroupName }}
					</div>
				</div>
			</ng-template>
			<ng-template let-GroupDescItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ GroupDescItem.GroupName }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<!-- <label>Active:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="ActiveID" [(ngModel)]="ActiveID">
			<option value="" style="display:none;"></option>
			<option *ngFor="let o of lstActive" [ngValue]="o.ID">{{o.Desc}}</option>
		</select> -->

		<!-- <label>Filter</label>
		<input class="form-control" type="text" placeholder="Student name, ID or barcode" [(ngModel)]="Filter"> -->
	</div>

	<button class="btn btn-primary" style="margin-top: 15px" (click)="onRefresh()">Search</button>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstPerson"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedPersons"
		dataKey="PersonID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--StudentID-->
				<th>
					<p-columnFilter type="text" field="StudentID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolNumber-->
				<th>
					<p-columnFilter field="SchoolFullName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSchoolNumber
								[ngModel]="value"
								[options]="lstSchoolFullName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--GradeLevelDesc-->
				<th>
					<p-columnFilter field="GradeLevelDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterGradeLevelDesc
								[ngModel]="value"
								[options]="lstGradeLevelDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Homeroom-->
				<th>
					<p-columnFilter field="Homeroom" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterHomeroom
								[ngModel]="value"
								[options]="lstHomeroom"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<!-- <th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterActiveDesc [ngModel]="value" [options]="lstActiveDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th> -->
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="StudentID">Student ID<p-sortIcon field="StudentID"></p-sortIcon></th>
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="SchoolNumber">School<p-sortIcon field="SchoolNumber"></p-sortIcon></th>
				<th pSortableColumn="GradeLevelDesc">Grade Level<p-sortIcon field="GradeLevelDesc"></p-sortIcon></th>
				<th pSortableColumn="Homeroom">Homeroom<p-sortIcon field="Homeroom"></p-sortIcon></th>
				<!-- <th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th> -->
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Person>
			<tr [pSelectableRow]="Person" (dblclick)="onRowDblClick(Person)">
				<td>
					<p-tableCheckbox [pSelectableRow]="Person" [value]="Person"></p-tableCheckbox>
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ Person[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAssign()">Assign</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
